import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'

interface PersonSelectorStyleProps {
  dropdownWrapperSx: SxProps
  mainWrapper: SxProps
  roomWrapper: SxProps
  room: SxProps
  adultsText: SxProps
  childrenAgeText: SxProps
  adultsWrapper: SxProps
  childrenWrapper: SxProps
  childSelectorWrapper: SxProps
  addRoomButton: SxProps
  addRoomWrapper: SxProps
  removeRoomButton: SxProps
  removeRoom: SxProps
  plusIcon: SxProps
  divider: SxProps
}

export const personSelectorStyle: PersonSelectorStyleProps = {
  dropdownWrapperSx: { zIndex: 'aboveDrawer' },
  mainWrapper: { display: 'flex', flexDirection: 'column', gap: 1.2, pb: '1px' },
  roomWrapper: { display: 'flex', flexDirection: 'column', gap: 1.2 },
  room: {
    typography: 'textXs',
    fontSize: '10px',
    fontWeight: FONT_WEIGHTS.STRONG,
    color: 'text.secondary700',
  },
  adultsText: {
    typography: 'textSmSemibold',
    color: 'text.primary900',
    fontWeight: FONT_WEIGHTS.HEAVY,
  },
  childrenAgeText: {
    typography: 'textXs',
    fontSize: '10px',
    fontWeight: FONT_WEIGHTS.HEAVY,
    color: 'text.primary900',
  },
  adultsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  childrenWrapper: { display: 'flex', flexDirection: 'column', gap: 1.2 },
  childSelectorWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addRoomButton: {
    alignSelf: 'flex-end',
  },
  addRoomWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 0.8,
    overflow: 'hidden',
  },
  removeRoomButton: {
    alignSelf: 'flex-end',
  },
  removeRoom: {
    typography: 'textSmSemibold',
    color: 'text.hyperLink',
    justifyContent: 'flex-end',
    display: 'flex',
  },

  plusIcon: {
    width: 20,
    height: 20,
    color: 'text.hyperLink',
  },
  divider: { backgroundColor: 'button.borderDisabled' },
}
